<template>
  <IconSvgBase
    :class="$style.path"
    :view-width="VIEW_SIZE"
    :view-height="VIEW_SIZE"
  >
    <defs>
      <clipPath :id="uid">
        <path
          d="M7.70789 0.256222C7.86846 -0.0854075 8.1313 -0.0854075 8.29208 0.256222L10.279 4.4833C10.4396 4.82493 10.8649 5.14941 11.224 5.20421L15.6672 5.8821C16.0265 5.9369 16.1077 6.19933 15.8478 6.46538L12.6326 9.75549C12.3728 10.0215 12.2103 10.5463 12.2718 10.922L13.0306 15.5677C13.092 15.9433 12.8793 16.1054 12.5581 15.9281L8.58401 13.7345C8.26286 13.5572 7.73711 13.5572 7.41596 13.7345L3.44184 15.9281C3.12069 16.1054 2.90798 15.9433 2.96934 15.5677L3.72819 10.922C3.78955 10.5463 3.62711 10.0215 3.36739 9.75549L0.152248 6.46538C-0.107673 6.19933 -0.0265228 5.9369 0.332612 5.8821L4.77597 5.20421C5.13504 5.14941 5.56045 4.82493 5.72096 4.4833L7.70789 0.256222Z"
        />
      </clipPath>
    </defs>
    <g :clip-path="`url(#${uid})`">
      <rect x="0" y="0" width="16" height="16" :class="$style['bg--room']" />
      <rect
        x="0"
        y="0"
        :width="normalizedRate * VIEW_SIZE"
        :height="VIEW_SIZE"
        :class="$style['bg--fill']"
      />
    </g>
  </IconSvgBase>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { nanoid } from 'nanoid'

import IconSvgBase from '@/components/icons/IconSvgBase.vue'

const VIEW_SIZE = 16
const minmax = (value: number, min: number, max: number): number =>
  Math.min(Math.max(value, min), max)

export default defineComponent({
  name: 'IconReviewStar',
  components: {
    IconSvgBase,
  },
  props: {
    rate: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const uid = computed(() => nanoid())
    const normalizedRate = computed(() => minmax(props.rate, 0, 1))

    return {
      uid,
      normalizedRate,
      VIEW_SIZE,
    }
  },
})
</script>

<style lang="scss" module>
.path {
  width: 1em;
  height: 1em;
}

.bg {
  &--room {
    fill: $color-surface-tertiary;
  }

  &--fill {
    fill: $color-text-and-object-accent-orange;
  }
}
</style>
